import cache from 'memory-cache';

const defaultTime = 8 * 60 * 60 * 1000; // hours * minutes * seconds * milliseconds

export const getCache = (key) => cache.get(key);
export const setCache = (key, value, time = defaultTime) =>
  cache.put(key, value, time);
